"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var LIGHT_TEXT_SHADOW = 'rgb(255, 255, 255) 1px 1px 4px';
var DARK_TEXT_SHADOW = 'rgb(0, 0, 0) 1px 1px 4px';
var DARK_TEXT_COLOR = 'rgb(0, 0, 0)';
var LIGHT_TEXT_COLOR = 'rgb(255, 255, 255)';
var makeProgressBarStyling = function (theme, useLightText) {
    return {
        container: (0, react_1.css)({
            height: 25,
            display: 'grid',
            width: '100%',
        }),
        progressBar: (0, react_1.css)({
            height: '100%',
            position: 'relative',
            gridRowStart: 1,
            gridColumnStart: 1,
            '& .MuiLinearProgress-barColorPrimary': {
                backgroundColor: theme.mvf.palette.component.progressBarFilledColor,
            },
            '&.MuiLinearProgress-colorPrimary': {
                backgroundColor: theme.mvf.palette.component.progressBarUnfilledColor,
            },
        }),
        text: (0, react_1.css)({
            gridRowStart: 1,
            gridColumnStart: 1,
            position: 'relative',
            width: 'inherit',
            zIndex: 1,
            lineHeight: '25px',
            fontSize: theme.mvf.fontSize.tiny,
            textShadow: useLightText ? DARK_TEXT_SHADOW : LIGHT_TEXT_SHADOW,
            color: useLightText ? LIGHT_TEXT_COLOR : DARK_TEXT_COLOR,
            textAlign: 'center',
            transition: 'color 0.5s ease, textShadow 0.5s ease',
        }),
    };
};
exports.default = makeProgressBarStyling;
//# sourceMappingURL=makeProgressBarStyling.js.map